import { Inject, Injectable } from '@angular/core';
import { HttpResponse } from '@angular/common/http';
import { isNil, omit } from 'lodash-es';
import { environment } from '../environments/environment';

import { UtilsService } from './utils.service';
import { SettingsValuesService } from './settings.values.service';

import { $frontendTypes } from './SalesOrders.frontend.types'

@Injectable({ providedIn: 'root' })
export class SalesOrders_get_order_substatuses_flowService {

  constructor(
    private $utils: UtilsService,
    private $settings: SettingsValuesService,
    ) { 
  }

  async run($inParams: { order_ids: number[] }): Promise<{ result?: { order_id: number, substatuses: string[], permissions?: $frontendTypes.SalesOrders.i_order_permissions }[], reasons?: string[] }> 
  {
    const $missingRequiredInParams = [];
    if (isNil($inParams.order_ids)) {
      $missingRequiredInParams.push('\'order_ids\'');
    }
    if ($missingRequiredInParams.length) {
    }
    let $url = `${environment.backendUrl}api/`;
    
    const $options = {
    }
    
    const $body = $inParams;
    
    return this.$utils.http.post($url, $body, $options);
    
  }

}

